import ReactGA from 'react-ga4'

let initialised = false

/**
 * Initialise GA4. No-op when VITE_GA_MEASUREMENT_ID is absent (local dev,
 * test environments, any build where the var is not set).
 */
export function initialiseAnalytics(): void {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID
  if (!measurementId) return

  ReactGA.initialize(measurementId)
  initialised = true
}

/**
 * Record a page view. Called on every route change.
 * Path should not contain query params or hashes that could carry PII.
 */
export function trackPageView(path: string): void {
  if (!initialised) return
  ReactGA.send({ hitType: 'pageview', page: path })
}

/**
 * Fire a named GA4 event.
 * Params must never contain PII (email, name, user ID, etc.).
 */
export function trackEvent(
  name: string,
  params?: Record<string, string | number | boolean>,
): void {
  if (!initialised) return
  ReactGA.event(name, params)
}
